import React, { useEffect, useRef, useState } from 'react'
import DashboardStyle from '../Dashboard'
import { customFuncsApi } from '../../../api'
import { get } from 'lodash'
import { ErrorModal } from '../../../components/Modal'
import ClipLoader from 'react-spinners/ClipLoader'
import moment from 'moment'
import Button from '../../../components/Button'
import EyeIcon2 from '../../../assets/icons/EyeIcon2'
import ViewSalesBySlpCode from '../../../components/Modal/ViewSalesBySlpCode/index'
import { BG_COLOR } from '../../../constants/colors'
import { useSelector } from 'react-redux'
const Tab2 = () => {
	const errorRef = useRef()
	const viewSalesRef = useRef()
	const { getMe } = useSelector((state) => state.main)

	const [startDate, setStartDate] = useState(
		moment().startOf('month').format('YYYY-MM-DD'),
	)

	const isRoleSotuv = ['Sotuv', 'Sotuv_sherik', 'Sherik'].includes(
		getMe?.Department2?.Name,
	)
	const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'))

	const [salesPersonLoading, setSalesPersonLoading] = useState(false)

	const [selesPersonSalesData, setSalesPersonSalesData] = useState([])

	const getSalesPersonSales = () => {
		setSalesPersonLoading(true)
		customFuncsApi(
			`xsSql/getSalesPersonSales?startDate=${startDate}&endDate=${endDate}&slpCode=${getMe?.EmployeeID}`,
			{
				headers: {
					Prefer: 'odata.maxpagesize=10000',
				},
			},
		)
			.then((res) => {
				const resData = res.data.value
				console.log('resData', resData)
				if (isRoleSotuv) {
					setSalesPersonSalesData(
						resData.filter(
							(item) =>
								item.SlpCode === getMe?.EmployeeID ||
								item.SlpCode === getMe?.SalesPersonCode,
						),
					)
					return
				}

				setSalesPersonSalesData(resData)
			})
			.catch((err) => {
				// errorRef.current?.open(
				//   get(JSON.parse(err.response.data), 'error.message', ''),
				// )
			})
			.finally(() => {
				setSalesPersonLoading(false)
			})
	}

	useEffect(() => {
		getSalesPersonSales()
	}, [startDate, endDate])

	const handleStartDateChange = (event) => {
		setStartDate(event.target.value)
	}

	const handleEndDateChange = (event) => {
		setEndDate(event.target.value)
	}

	return (
		<DashboardStyle
			style={{
				backgroundColor: BG_COLOR,
			}}
		>
			<div className="container">
				<p className="productTitle mb-10">Показатели продаж</p>
				<div className="flex gap-4">
					<div>
						<p className={'font-medium text-zinc-600 text-sm mb-1'}>
							Дата начала
						</p>
						<input
							className={'border-[1px] border-[#DFE2E9"] p-1 rounded-md'}
							type="date"
							value={startDate}
							onChange={handleStartDateChange}
						/>
					</div>
					<div>
						<p className={'font-medium text-zinc-600 text-sm mb-1'}>
							Дата окончания
						</p>
						<input
							className={'border-[1px] border-[#DFE2E9"] p-1 rounded-md '}
							type="date"
							value={endDate}
							onChange={handleEndDateChange}
						/>
					</div>
				</div>
				<div>
					<h4 className={'font-bold text-lg text-center mt-10 mb-4'}>
						Показатели продаж
					</h4>
					{salesPersonLoading ? (
						<div style={{ display: 'flex', justifyContent: 'center' }}>
							<ClipLoader
								loading={true}
								size={20}
								aria-label="Loading Spinner"
								className={'loader'}
								data-testid="loader"
							/>
						</div>
					) : (
						<div className="overflow-y-auto mb-8">
							<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
								<thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
									<tr>
										<th scope="col" className="px-6 py-4">
											Имя продавца
										</th>
										<th scope="col" className="px-6 py-4">
											Наличные продажи
										</th>
										<th scope="col" className="px-6 py-4">
											План Наличные
										</th>
										<th scope="col" className="px-6 py-4">
											Выполнено Наличные
										</th>
										<th scope="col" className="px-6 py-4">
											Рассрочка
										</th>
										<th scope="col" className="px-6 py-4">
											План Рассрочка
										</th>
										<th scope="col" className="px-6 py-4">
											Выполнено Рассрочка
										</th>
										<th scope="col" className="px-6 py-4">
											Действие
										</th>
									</tr>
								</thead>
								<tbody>
									{selesPersonSalesData?.map((v, i) => {
										return (
											<tr
												key={i}
												className="bg-white border-b  hover:bg-gray-50 "
											>
												<td
													scope="row"
													className="px-6 py-4 font-medium text-gray-900 "
												>
													{get(v, 'Sales Employee', '')}
												</td>
												<td className="px-6 py-4">
													{get(v, 'Single Installment', '')}
												</td>
												<td className="px-6 py-4"> {get(v, 'Plan', '')}</td>
												<td className="px-6 py-4">
													{' '}
													{Number(get(v, 'Single Installment') || 0) /
														Number(get(v, 'Plan') || 0) >
														0 &&
														get(v, 'Plan') &&
														`${(
															(Number(get(v, 'Single Installment') || 0) /
																Number(get(v, 'Plan') || 0)) *
															100
														).toFixed(2)} %`}
												</td>
												<td className="px-6 py-4">
													{' '}
													{get(v, 'Multiple Installments', '')}
												</td>

												<td className="px-6 py-4">
													{' '}
													{get(v, 'PlanMulti', '')}
												</td>

												<td className="px-6 py-4">
													{Number(get(v, 'Multiple Installments') || 0) /
														Number(get(v, 'PlanMulti') || 0) >
														0 &&
														get(v, 'PlanMulti') &&
														`${(
															(Number(get(v, 'Multiple Installments') || 0) /
																Number(get(v, 'PlanMulti') || 0)) *
															100
														).toFixed(2)} %`}
												</td>
												<td
													scope="row"
													className="px-6 py-4 font-medium text-gray-900"
												>
													<Button
														onClick={() => {
															viewSalesRef.current?.open({
																startDate: startDate,
																endDate: endDate,
																SlpCode: v?.SlpCode,
															})
														}}
														className="!w-8 !h-10"
													>
														<EyeIcon2 />
													</Button>
												</td>
											</tr>
										)
									})}
								</tbody>
								<tfoot className="bg-gray-200 ">
									<tr>
										<td className="px-6 py-4" colSpan="1">
											<span className="font-bold">Итого</span>
										</td>
										<td className="px-6 py-4">
											{selesPersonSalesData?.reduce(
												(acc, v) => acc + +get(v, 'Single Installment', 0),
												0,
											)}
										</td>
										<td className="px-6 py-4" colSpan="2"></td>
										<td className="px-6 py-4">
											{selesPersonSalesData?.reduce(
												(acc, v) => acc + +get(v, 'Multiple Installments', 0),
												0,
											)}
										</td>
										<td className="px-6 py-4" colSpan="2"></td>
										<td className="px-6 py-4" colSpan="2"></td>
										<td className="px-6 py-4" colSpan="2"></td>
									</tr>
								</tfoot>
							</table>
						</div>
					)}
				</div>
			</div>
			<>
				<ErrorModal
					getRef={(r) => {
						errorRef.current = r
					}}
				/>
				<ViewSalesBySlpCode getRef={(r) => (viewSalesRef.current = r)} />
			</>
		</DashboardStyle>
	)
}

export default Tab2
